export const EXTRANET_PRICING_MODES = {
  AIR_TO_ANY: "AIR_TO_ANY",
  AIR_TO_ZONE: "AIR_TO_ZONE",
  ANY_TO_ANY: "ANY_TO_ANY",
  ANY_TO_ZONE: "ANY_TO_ZONE",
  ZONE_TO_ZONE: "ZONE_TO_ZONE",
};

export const EXTRANET_PRICING_MODES_ARRAY = Object.values(
  EXTRANET_PRICING_MODES
);
